import React, { useEffect, useState } from "react";

import "./index.scss";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
function PaiementsResponsiveCards({
  paiements,
  handleStatus,
  setAction,
  loadData,
  setSelectedId,
}) {
  const [plus, setPlus] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration (in milliseconds)
    });
    AOS.refresh();
  }, []);

  return (
    <div id="AbonnementResponsiveCards">
      <div className="card my-4">
        <div className="d-flex ps-3 mt-3 align-items-center ">
          <span className="title me-3">Transaction id:</span>
          <span>{paiements?.transaction_id}</span>
        </div>
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3">Montant:</span>
          <span>{paiements?.amount}</span>
        </div>{" "}
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3"> Date:</span>
          <span>{paiements?.created_at}</span>
        </div>{" "}
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3">Email: </span>
          <span>{paiements?.email}</span>
        </div>{" "}
        <hr />
        <div className="d-flex ps-3 align-items-center ">
          <span className="title me-3">Status: </span>
          <span
            style={{
              padding: "5px 10px",
              borderRadius: "12px",
              color: paiements?.status === "COMPLETED" ? "#00AC0E" : "#EE0202",
              backgroundColor:
                paiements?.status === "COMPLETED" ? "#D2FFD6" : "#FFD8D8",
            }}
          >
            {paiements?.status != null && paiements?.status}
          </span>
        </div>
        {plus && (
          <div data-aos="fade-down">
            <hr />
            <div className="d-flex ps-3 align-items-center ">
              <span className="title me-3">Nom et Prénom:</span>
              <span>
                {paiements?.nom} &nbsp;
                {paiements?.prenom}
              </span>
            </div>
            <hr />
            <div className="d-flex ps-3 align-items-center ">
              <span className="title me-3">Téléphone:</span>
              <span>{paiements?.telephone}</span>
            </div>{" "}
            <hr />
            <div className="d-flex ps-3 align-items-center ">
              <span className="title me-3">Pays:</span>
              <span>{paiements?.pays}</span>
            </div>{" "}
          </div>
        )}
        <hr className="mb-0" />
        <div className="d-flex align-items-center ps-3 ">
          <div className="d-flex justify-content-center align-items-center">
            <button
              onClick={() => setPlus(!plus)}
              className="btn btn-link"
              type="button"
            >
              <label className="mx-1">
                <i className="bi bi-eye" style={{ fontSize: "20px" }}></i>
              </label>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaiementsResponsiveCards;
